import React from "react"

import { useTranslation } from "@bounce/i18n"
import type { HowItWorksProps } from "@bounce/web-components"
import { HowItWorks } from "@bounce/web-components"

import { useBenefits } from "./useBenefits"

export type WhyBecomePartnerProps = {
  title?: string
} & Omit<HowItWorksProps, "steps" | "title">

export const WhyBecomePartner = ({ title, ...props }: WhyBecomePartnerProps) => {
  const { t } = useTranslation("marketing-partner")
  const benefits = useBenefits()

  return (
    <HowItWorks
      steps={benefits}
      title={title || t("cmp.partner.whyBecomePartner.titleV2", "Why become a Partner?")}
      {...props}
    />
  )
}
